<template>
  <div>
    <woot-button
      v-if="hasCreatePermission('Teams')"
      color-scheme=""
      class="button-filled"
      icon="add"
      @click="showModal = true"
    >
      {{ $t('TEAMS_SETTINGS.NEW_TEAM') }}
    </woot-button>
    <team-modal v-if="showModal" :on-close="closeModal" />
  </div>
</template>

<script>
import hasPermissionMixin from 'dashboard/mixins/hasPermission';
import TeamModal from './TeamModal.vue';

export default {
  components: { TeamModal },
  mixins: [hasPermissionMixin],
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>
